import { render } from "./OrderTools.vue?vue&type=template&id=3985dc96&scoped=true"
import script from "./OrderTools.vue?vue&type=script&lang=js"
export * from "./OrderTools.vue?vue&type=script&lang=js"

import "./OrderTools.vue?vue&type=style&index=0&id=3985dc96&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3985dc96"]])

export default __exports__